import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { AppHeaderPresenter } from './app-header.presenter';
import { AbstractView } from '@core/interfaces';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DropdownModule,
  ],
  templateUrl: './app-header.component.html',
  styleUrl: './app-header.component.scss'
})
export class AppHeaderComponent extends AbstractView<AppHeaderPresenter>
  implements OnInit, OnDestroy {

  dropdownAccountDataKey = this.presenter.dropdownAccountDataKey;
  selectAccount = this.presenter.selectAccount;
  selectorLanguage = this.presenter.selectorLanguage;
  languages = this.presenter.languages;
  accounts = this.presenter.accounts;
  userFullname = this.presenter.userFullname;
  userRole = this.presenter.userRole;

  constructor(
    messageService: MessageService,
    router: Router,
    store: Store,
    presenter: AppHeaderPresenter
  ) {
    super(messageService, router, store, presenter);
  }
  
  ngOnInit(): void {
    this.presenter.setView(this);
  }

  ngOnDestroy(): void {
    this.presenter.onDestroy();
  }

  showProfileSidebar(): void {
    this.presenter.showProfileSidebar();
  }

  changeSelectAccount(event: DropdownChangeEvent): void {
    this.presenter.changeSelectAccount(event);
  }
}
